import axios from 'axios';
import cfg from '../config.json';
import _, { cloneDeep } from 'lodash';
import Moment from 'moment';

import Comm from '../models/comm';

import { showLoading, showInfo, showErrorResponse, clearMsg } from './msgReducer';

//================== Whole State ==================//
const initialState = {
    isLoading: false,
    isFilterUpdated: false,
    filter: { // match EntitiesResult<T>
        allRecords: 0,
        matchedRecords: 0,
        totalRecords: 0,
        qtyPerPage: 100,
        page: 1,
        row: 0,
        filter: "[]",
        sort: JSON.stringify([{ "property": "DateDeposit", "direction": "DESC" }]),
        success: true,
        message: '',
    },
    entities: [],
    errors: '',
    workingEntityId: -1,
    workingEntity: null,
    workingEntityErrors: '',
};


//================== Action Types ==================//
export const ReportCommReducedActions = Object.freeze({
    // filter
    FILTER_UPDATE: Symbol("FILTER_UPDATE"),
    CHANGE_SORT: Symbol("CHANGE_SORT"),
    PAGE_UPDATE: Symbol("PAGE_UPDATE"),
    FETCH_PAGE: Symbol("FETCH_PAGE"), 

    // listing
    REQUEST: Symbol("REQUEST"), 
    SUCCESS: Symbol("SUCCESS"), 
    FAILURE: Symbol("FAILURE"),

    DETAIL_ID: Symbol("DETAIL_ID"),
    GOTO_COMM_DETAIL: Symbol("GOTO_COMM_DETAIL"),
});


//================== Action Creators ==================//
export const reportCommReducedFilterUpdate = (field, value) => {
    return {
        type: ReportCommReducedActions.FILTER_UPDATE,
        payload: {
            field: field,
            value: value
        }
    }
}

const _setWorkingEntityId = (id) => {
    return {
        type: ReportCommReducedActions.DETAIL_ID,
        payload: id,
    }
}

export const reportCommReducedFilterClear = () => {
    return (dispatch) => {
        dispatch(_setWorkingEntityId(initialState.workingEntityId));
        dispatch(reportCommReducedLookup(initialState.filter));
    }
}

export const reportCommReducedChangeSort = (field) => {
    return (dispatch, getState) => {
        dispatch({
            type: ReportCommReducedActions.CHANGE_SORT,
            payload: field,
        });
        const { reportCommReduced: { filter } } = getState(); // state updated
        //console.log(filter);
        dispatch(reportCommReducedLookup(filter));
    };
}

export const reportCommReducedPageUpdate = (page) => {
    return (dispatch, getState) => {
        const { reportCommReduced: { filter } } = getState(); // state updated

        let _page = 1;

        if (page == "") {
            _page = "";
        } else {
            _page = parseInt(page);
            if (_.isNaN(_page)) return;
            if (_page < 1) _page = 1;
            if (_page > Math.ceil(filter.matchedRecords / filter.qtyPerPage)) _page = Math.ceil(filter.matchedRecords / filter.qtyPerPage);
        }

        dispatch({
            type: ReportCommReducedActions.FETCH_PAGE,
            payload: _page,
        });
    };
}

export const reportCommReducedFetchPage = (page) => {
    return (dispatch, getState) => {
        dispatch({
            type: ReportCommReducedActions.FETCH_PAGE,
            payload: page,
        });
        const { reportCommReduced: { filter } } = getState(); // state updated
        //console.log(filter);
        dispatch(reportCommReducedLookup(filter));
    };
}

const _reportCommReducedRequest = () => {
    return {
        type: ReportCommReducedActions.REQUEST
    }
}

const _reportCommReducedSuccess = (data) => {
    return {
        type: ReportCommReducedActions.SUCCESS,
        payload: data,
    }
}

const _reportCommReducedFailure = (response) => {
    return {
        type: ReportCommReducedActions.FAILURE,
        payload: response,
    }
}

export const reportCommReducedLookup = (formData) => {
    const _formData = formData ? formData : initialState.filter;
    //console.log(_formData);
    const apiEndpoint = `${cfg.ApiOrigin == "window.location.origin" ? window.location.origin : cfg.ApiOrigin}/api/ReportCommReduced/GetEntities`;

    return (dispatch, getState) => {
        dispatch(_reportCommReducedRequest());

        const { reportCommReduced } = getState(); // state updated
        if (reportCommReduced.isFilterUpdated) _formData.page = 1; // reset page if filter changed
        if (reportCommReduced.filter.page == "") _formData.page = 1; // reset page if filter changed

        axios.post(apiEndpoint, _formData, {
            timeout: 30000,
        })
            .then(response => {
                if (response.data) {
                    dispatch(_reportCommReducedSuccess(response.data)); 
                } else {
                    dispatch(_reportCommReducedFailure("未能讀取"));
                }
            })
            .catch(error => {
                dispatch(_reportCommReducedFailure("未能讀取"));
                dispatch(showErrorResponse(error));
            })
    }
}

export const gotoCommDetail = (idComm) => {
    return {
        type: ReportCommReducedActions.GOTO_COMM_DETAIL,
        payload: idComm,
    }
}
//================== Reducer ==================//
const reportCommReducedReducer = (state = initialState, action) => {
    let _state = cloneDeep(state);
    let i = -1;

    switch (action.type) {
        case ReportCommReducedActions.FILTER_UPDATE:
            const { field: filterField, value } = action.payload;
            let filters = JSON.parse(state.filter.filter);
            const iFilter = _.findIndex(filters, function (o) { return o.property == filterField; });
            if (iFilter >= 0) {
                if (value) filters[iFilter].value = value;
                else filters.splice(iFilter, 1);
            } else {
                filters.push({ "property": filterField, "value": value });
            }

            _state.filter.filter = JSON.stringify(filters);
            _state.isFilterUpdated = true;
            //console.log('_state.filter', _state.filter.filter);
            return _state;

        case ReportCommReducedActions.CHANGE_SORT:
            const field = action.payload;
            let sorts = JSON.parse(state.filter.sort);
            i = _.findIndex(sorts, function (o) { return o.property == field; });
            if (i >= 0) {
                sorts[i].direction = sorts[i].direction == "ASC" ? "DESC" : "ASC";
            } else {
                // single sort only
                sorts = [{ "property": field, "direction": "ASC" }];
            }

            _state.filter.sort = JSON.stringify(sorts);
            //console.log('_state.filter.sort', _state.filter.sort);

            reportCommReducedLookup(_state.filter);
            return _state;

        case ReportCommReducedActions.PAGE_UPDATE:
            _state.filter.page = action.payload;
            return _state;

        case ReportCommReducedActions.FETCH_PAGE:
            _state.filter.page = action.payload;
            return _state;

        case ReportCommReducedActions.REQUEST:
            _state.isLoading = true;
            return _state;

        case ReportCommReducedActions.SUCCESS:
            _state.isLoading = false;
            _state.filter = {
                allRecords: action.payload.allRecords,
                matchedRecords: action.payload.matchedRecords,
                totalRecords: action.payload.totalRecords,
                qtyPerPage: action.payload.qtyPerPage,
                page: action.payload.page,
                row: action.payload.row,
                filter: action.payload.filter,
                sort: action.payload.sort,
                success: action.payload.success,
                message: action.payload.message,
            };
            _state.entities = action.payload.entities;
            _state.errors = "";
            _state.isFilterUpdated = false;
            return _state;

        case ReportCommReducedActions.FAILURE:
            _state.isLoading = false;
            _state.errors = action.payload;
            _state.entities = [];
            return _state;

        case ReportCommReducedActions.DETAIL_ID:
            _state.workingEntityId = action.payload;
            return _state;

        case ReportCommReducedActions.GOTO_COMM_DETAIL:
            _state.workingEntityId = action.payload;
            return _state;

        default:
            return state;
    }
}

export default reportCommReducedReducer;

